/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetAiAgentSettingResponse } from '../model/getAiAgentSettingResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateAiAgentServiceSettingsRequest } from '../model/updateAiAgentServiceSettingsRequest';
import type { UpdateAiAgentServiceSettingsResponse } from '../model/updateAiAgentServiceSettingsResponse';
import type { UpdateAiAgentSettingRequest } from '../model/updateAiAgentSettingRequest';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * Get the general AI agent enabled setting (master switch) and all AI agent service settings for the office
 * @deprecated
 * @summary Get AI agent setting for current office
 */
export const useGetAiAgentSettingHook = () => {
  const getAiAgentSetting = useCustomClient<GetAiAgentSettingResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getAiAgentSetting(
      { url: `/api/js/ai_agent_setting`, method: 'GET', signal },
      options
    );
  };
};

export const getGetAiAgentSettingQueryKey = () => {
  return [`/api/js/ai_agent_setting`] as const;
};

export const useGetAiAgentSettingQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiAgentSettingQueryKey();

  const getAiAgentSetting = useGetAiAgentSettingHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>
  > = ({ signal }) => getAiAgentSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAiAgentSettingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>
>;
export type GetAiAgentSettingQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @deprecated
 * @summary Get AI agent setting for current office
 */
export const useGetAiAgentSetting = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetAiAgentSettingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetAiAgentSettingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiAgentSettingQueryKey();

  const getAiAgentSetting = useGetAiAgentSettingHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>
  > = ({ signal }) => getAiAgentSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAiAgentSettingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>
>;
export type GetAiAgentSettingSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @deprecated
 * @summary Get AI agent setting for current office
 */
export const useGetAiAgentSettingSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetAiAgentSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetAiAgentSettingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Update the general AI agent enabled setting (master switch) for the office
 * @deprecated
 * @summary Update AI agent setting for current office
 */
export const useUpdateAiAgentSettingHook = () => {
  const updateAiAgentSetting = useCustomClient<void>();

  return (
    updateAiAgentSettingRequest: BodyType<UpdateAiAgentSettingRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateAiAgentSetting(
      {
        url: `/api/js/ai_agent_setting`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateAiAgentSettingRequest,
      },
      options
    );
  };
};

export const useUpdateAiAgentSettingMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentSettingHook>>>,
    TError,
    { data: BodyType<UpdateAiAgentSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentSettingHook>>>,
  TError,
  { data: BodyType<UpdateAiAgentSettingRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateAiAgentSetting = useUpdateAiAgentSettingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentSettingHook>>>,
    { data: BodyType<UpdateAiAgentSettingRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAiAgentSetting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiAgentSettingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentSettingHook>>>
>;
export type UpdateAiAgentSettingMutationBody =
  BodyType<UpdateAiAgentSettingRequest>;
export type UpdateAiAgentSettingMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @deprecated
 * @summary Update AI agent setting for current office
 */
export const useUpdateAiAgentSetting = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentSettingHook>>>,
    TError,
    { data: BodyType<UpdateAiAgentSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useUpdateAiAgentSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update multiple AI agent service settings for the current office.
 * @summary Update AI agent service settings for current office
 */
export const useUpdateAiAgentServiceSettingsHook = () => {
  const updateAiAgentServiceSettings =
    useCustomClient<UpdateAiAgentServiceSettingsResponse>();

  return (
    updateAiAgentServiceSettingsRequest: BodyType<UpdateAiAgentServiceSettingsRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateAiAgentServiceSettings(
      {
        url: `/api/js/ai_agent_service_settings`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateAiAgentServiceSettingsRequest,
      },
      options
    );
  };
};

export const useUpdateAiAgentServiceSettingsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentServiceSettingsHook>>>,
    TError,
    { data: BodyType<UpdateAiAgentServiceSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentServiceSettingsHook>>>,
  TError,
  { data: BodyType<UpdateAiAgentServiceSettingsRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateAiAgentServiceSettings = useUpdateAiAgentServiceSettingsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentServiceSettingsHook>>>,
    { data: BodyType<UpdateAiAgentServiceSettingsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAiAgentServiceSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiAgentServiceSettingsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentServiceSettingsHook>>>
>;
export type UpdateAiAgentServiceSettingsMutationBody =
  BodyType<UpdateAiAgentServiceSettingsRequest>;
export type UpdateAiAgentServiceSettingsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update AI agent service settings for current office
 */
export const useUpdateAiAgentServiceSettings = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiAgentServiceSettingsHook>>>,
    TError,
    { data: BodyType<UpdateAiAgentServiceSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpdateAiAgentServiceSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};
